import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/luggage-storage-for-business-travelers.jpg'),
    alt: 'luggage storage for business travelers page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'luggage storage for business travelers page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Secure <span>Luggage</span><span>Storage For Business Travelers</span>',
  description:
    'When you’re traveling for business, the last thing you want to worry about is your luggage. Our secure luggage storage for business travelers provides you with a safe, convenient solution to store your belongings while you focus on your work.',
  image: {
    url: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/hero-image.jpg',
    alt: 'Secure Luggage Storage For Business Travelers'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Business Traveler Luggage' }
}

export const ourProcessSectionContent = {
  title: 'Convenient Luggage Storage For Business Travelers',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Reserve Your Luggage Storage' },

  image: {
    url: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/convenient-luggage-storage-for-business-travelers.png',
    alt: 'Convenient Luggage Storage For Business Travelers'
  },

  articles: [
    {
      id: 1,
      title: 'Book Your Storage Online',
      description: 'Simply book your luggage storage through our easy-to-use online platform.',
      image: {
        src: '/images/v2/pages/common/express-delivery-options.png',
        alt: 'Book Your Storage Online'
      }
    },
    {
      id: 2,
      title: 'Drop Off at Convenient Locations',
      description: 'Easily drop off your luggage near airports and business hubs.',
      image: {
        src: '/images/v2/pages/common/drop-off-at-convenient-locations.png',
        alt: 'Drop Off at Convenient Locations'
      }
    },
    {
      id: 3,
      title: 'Pick Up Anytime',
      description:
        'Retrieve your luggage whenever you need it, ensuring it’s ready for your next business meeting or flight.',
      image: {
        src: '/images/v2/pages/common/pick-up-anytime.png',
        alt: 'Pick Up Anytime'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast And Secure Luggage Storage For Travelers',
  description:
    "Our luggage storage services are designed for business travelers who need speed and security. We ensure your belongings are stored safely in high-quality facilities while also offering rapid access when you need it. Whether you're in town for a day or a week, you can trust us to keep your luggage secure.",
  image: {
    src: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/fast-and-secure-luggage-storage-for-travelers.jpg',
    alt: 'Fast And Secure Luggage Storage For Travelers'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Luggage Storage Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'With easily accessible locations and a simple online booking process, storing your luggage is hassle-free.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Affordability',
      description:
        'Our state-of-the-art storage facilities ensure your luggage is protected, giving you peace of mind during your travels.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordability'
      }
    },
    {
      id: 3,
      title: 'Flexibility',
      description:
        'Need to store your bags for a few hours, a day, or more? Our flexible storage options cater to your needs.',
      image: {
        src: '/images/v2/pages/common/improved-compliance.png',
        alt: 'Flexibility'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Luggage Storage for Business Travelers?',

  articles: [
    {
      content: [
        {
          id: 1,
          title:
            "Our luggage storage services are perfect for business professionals who require flexibility and convenience during their travels. Whether you're attending meetings, conferences, or just passing through, our services ensure that your luggage is safely stored, leaving you free to focus on your business needs."
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/who-should-choose-us-for-luggage-storage-for-business-travelers.jpg',
        alt: 'Who Should Choose Us for Luggage Storage for Business Travelers?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',
  description: 'At ShipAndStorage, we offer a variety of shipping and storage services tailored to fit every need:',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description: 'Perfect for homeowners or renters looking to store household items for short or long periods.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description:
        'A convenient solution for individuals or families in between moves, ensuring a smooth transition with flexible storage options.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description:
        'Ideal for companies needing extra space for files, equipment, or seasonal items, with pickup and delivery options.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description:
        'Affordable storage for students during breaks, keeping their belongings safe and secure until they return.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage And Shipping Services?',

  image: {
    url: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/why-choose-shipandstorage-for-storage-and-shipping-services.jpg',
    alt: 'Why Choose ShipAndStorage for Storage And Shipping Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description: 'Store your luggage or other belongings for as long as needed.'
    },
    {
      id: 2,
      title: 'Quick and Easy Booking',
      description: 'Simple online booking process, saving you time and hassle.'
    },
    {
      id: 3,
      title: 'Convenient Locations',
      description: 'Easily accessible storage locations near airports and business centers.'
    },
    {
      id: 4,
      title: 'Affordable Pricing',
      description: 'Competitive pricing to suit your budget, without compromising on quality.'
    },
    {
      id: 5,
      title: '24/7 Security',
      description: 'Your items are always protected with round-the-clock surveillance.'
    },
    {
      id: 6,
      title: 'Reliable Service',
      description: 'Dependable storage solutions that business travelers trust for their essential items.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Luggage Storage For Business Travelers Secure And Convenient',
  description:
    'Luggage storage for business travelers. Fast, secure, and convenient options for storing luggage while on business trips.',
  image: {
    src: '/images/v2/pages/landing-pages/luggage-storage-for-business-travelers/luggage-storage-for-business-travelers-secure-and-convenient.png',
    alt: 'Luggage Storage For Business Travelers Secure And Convenient'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Storing Your Luggage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we partner with leading logistics providers to deliver secure, reliable, and high-quality storage and shipping solutions. Our collaborations ensure that your belongings are treated with care and safely delivered to their destination.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a globally recognized leader in logistics, providing secure storage and efficient transportation solutions for your items.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers secure and reliable global logistics services, ensuring safe storage and transportation of your belongings throughout the year.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure storage solutions and global shipping services, ensuring your belongings are handled with care from pickup to delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
